import API from "../configs/axiosInstance";

const _dashboardQuery = (p = {}) => {
  const q = new URLSearchParams();
  if (p.domainId != null && p.domainId !== "") {
    q.set("domainId", String(p.domainId));
  }
  if (p.limit != null && p.limit !== "") {
    q.set("limit", String(p.limit));
  }
  if (p.days != null && p.days !== "") {
    q.set("days", String(p.days));
  }
  const s = q.toString();
  return s ? `?${s}` : "";
};

const getDashboardSummary = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/summary${_dashboardQuery(params)}`,
    method: "GET",
  });
};

const getDashboardLeaksByDataType = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/leaks-by-data-type${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDashboardLeaksByBreachType = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/leaks-by-breach-type${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDashboardLookalikeByDataType = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/lookalike-by-data-type${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDashboardThirdPartyDatabases = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/third-party-databases${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDashboardTopDomainsByLeaks = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/top-domains-by-leaks${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDashboardActivity = (params) => {
  return API({
    url: `account-service/v1/dark-web/dashboard/activity${_dashboardQuery(
      params
    )}`,
    method: "GET",
  });
};

const getDarkWebLastLeaksPageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebUniqueDomainsPageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/unique-domains/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebDomainScanHistory = ({ domainName, params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/pageable`,
    method: "POST",
    params,
    data: {
      ...data,
      domainName,
    },
  });
};

const getDarkWebLeaksPageable = ({ darkWebId, params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/${darkWebId}/leaks`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebLookalikePageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/lookalike/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebLookalikeUniqueDomainsPageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/lookalike/unique-domains/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebLookalikeScanHistory = ({ domainName, params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/lookalike/pageable`,
    method: "POST",
    params,
    data: {
      ...data,
      domainName,
    },
  });
};

const getDarkWebLookalikeItemsPageable = ({
  lookalikeId,
  params = {},
  data = {},
} = {}) => {
  return API({
    url: `account-service/v1/dark-web/lookalike/${lookalikeId}/items`,
    method: "POST",
    params,
    data,
  });
};

const getThirdPartyDbPageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getThirdPartyDbUniqueDomainsPageable = ({ params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/unique-domains/pageable`,
    method: "POST",
    params,
    data,
  });
};

const getThirdPartyDbScanHistory = ({ domainName, params = {}, data = {} } = {}) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/pageable`,
    method: "POST",
    params,
    data: {
      ...data,
      domainName,
    },
  });
};

const getThirdPartyDbLeaksPageable = ({
  thirdPartyDbId,
  params = {},
  data = {},
} = {}) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/${thirdPartyDbId}/leaks`,
    method: "POST",
    params,
    data,
  });
};

const getThirdPartyDbLeakAccountsPageable = ({
  leakId,
  params = {},
  data = {},
} = {}) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/leaks/${leakId}/accounts`,
    method: "POST",
    params,
    data,
  });
};

const getDarkWebLastLeaksHasData = (domainId) => {
  return API({
    url: `account-service/v1/dark-web/${domainId}/has-data`,
    method: "GET",
  });
};

const getDarkWebLookalikeHasData = (domainId) => {
  return API({
    url: `account-service/v1/dark-web/lookalike/${domainId}/has-data`,
    method: "GET",
  });
};

const getDarkWebThirdPartyDbHasData = (domainId) => {
  return API({
    url: `account-service/v1/dark-web/third-party-db/${domainId}/has-data`,
    method: "GET",
  });
};

const darkWebService = {
  getDarkWebLastLeaksPageable,
  getDarkWebUniqueDomainsPageable,
  getDarkWebDomainScanHistory,
  getDarkWebLeaksPageable,
  getDarkWebLookalikePageable,
  getDarkWebLookalikeUniqueDomainsPageable,
  getDarkWebLookalikeScanHistory,
  getDarkWebLookalikeItemsPageable,
  getThirdPartyDbPageable,
  getThirdPartyDbUniqueDomainsPageable,
  getThirdPartyDbScanHistory,
  getThirdPartyDbLeaksPageable,
  getThirdPartyDbLeakAccountsPageable,
  getDarkWebLastLeaksHasData,
  getDarkWebLookalikeHasData,
  getDarkWebThirdPartyDbHasData,
  getDashboardSummary,
  getDashboardLeaksByDataType,
  getDashboardLeaksByBreachType,
  getDashboardLookalikeByDataType,
  getDashboardThirdPartyDatabases,
  getDashboardTopDomainsByLeaks,
  getDashboardActivity,
};

export default darkWebService;
